/**
 * HomeGroupWA Contact Page JS Include
 *
 * @author Strange Animals <info@strangeanimals.com.au>
 */

$(function() {
    //Google Map Setup
    var map;
    if (typeof $mapDataSource !== 'undefined') {
        var markerData = JSON.parse('$mapDataSource');
        var markerBounds = new google.maps.LatLngBounds();
        var mapMarkers = [];
        var bouncingMarker = false;

        var infowindow = new google.maps.InfoWindow({
            content: '',
            maxWidth: 380
        });

        google.maps.event.addListener(infowindow, 'closeclick', function() {
            if (bouncingMarker) {
                bouncingMarker.setAnimation(null);
            }
        });

        function getParameterByName(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
                results = regex.exec(location.search);
            return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }

        function initializeContactMap() {
            var myLatlng = new google.maps.LatLng(-25.363882, 131.044922);
            var mapOptions = {
                zoom: 14,
                center: myLatlng
            };

            var highlightMarkerSelector = getParameterByName('onmap');
            var hightlightMarker = false;

            map = new google.maps.Map(document.getElementById('ContactPageMap'), mapOptions);

            $.each(markerData, function(idx, location) {
                var pos = new google.maps.LatLng(parseFloat(location.Latitude), parseFloat(location.Longitude));
                var marker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    title: location.Title
                });

                if (location.HasMarkerImage) marker.setIcon(location.MarkerImage);

                mapMarkers.push(marker);
                markerBounds.extend(pos);

                if (highlightMarkerSelector && highlightMarkerSelector == location.Selector) {
                    hightlightMarker = marker;
                }

                google.maps.event.addListener(marker, 'click', function() {
                    var loc = '';
                    if (location.Content != undefined) {
                        loc = location.Content;
                    } else {
                        loc = location.Title;
                    }
                    infowindow.close();
                    infowindow.setContent('<div class="contact-page-map-marker">' + loc + '</div>');
                    infowindow.open(map, marker);
                    map.panTo(marker.getPosition());

                    if (bouncingMarker && bouncingMarker !== marker) {
                        bouncingMarker.setAnimation(null);
                    }

                    if (marker.getAnimation() != null) {
                        marker.setAnimation(null);
                        bouncingMarker = false;
                    } else {
                        marker.setAnimation(google.maps.Animation.BOUNCE);
                        bouncingMarker = marker;
                    }
                });
            });

            google.maps.event.addListenerOnce(map, 'idle', function() {
                if (markerData.length === 1) {
                    map.setCenter(
                        new google.maps.LatLng(parseFloat(markerData[0].Latitude), parseFloat(markerData[0].Longitude))
                    );
                } else {
                    map.fitBounds(markerBounds);
                }

                if (hightlightMarker) {
                    setTimeout(function() {
                        google.maps.event.trigger(hightlightMarker, 'click');
                    }, 500);
                }
            });
        }

        jQuery(document).ready(function() {
            initializeContactMap();
        });
    }
});
